import Component from '../abstracts/Component';
import TrackingComponent from './TrackingComponent';
import OnDemandLiveRegion from "../utils/OnDemandLiveRegion";

export default class SizeSelectorComponent extends Component {

  get COMPONENTNAME() {
    return 'SizeSelectorComponent';
  }

  get SELECTORS() {
    return {
      size: '[data-size] input',
      sizeRadioBox: '[data-size]',
      selectedSize: '[data-js-size-selected]',
      wishlistSize: '[data-sizes-select] select',
      lowStockMsg: '[data-js-low-stock]',
      noSizeMsg: '[data-js-no-size]',
    };
  }

  get CLASSES() {
    return {
      selected: 'selected',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.TrackingComponent = new TrackingComponent();
    this.liveRegion = new OnDemandLiveRegion({
      level: "assertive",
      delay: 1000,
    });
  }

  readDOM() {
    return {
      box: this.$component,
      sizes: this.$component.querySelectorAll(this.SELECTORS.size),
      wishlistSize: this.$component.querySelector(this.SELECTORS.wishlistSize),
      lowStockMsg: this.$component.querySelector(this.SELECTORS.lowStockMsg),
      noSizeMsg: this.$component.querySelector(this.SELECTORS.noSizeMsg),
      selectedSize: document.querySelector(this.SELECTORS.selectedSize)
    };
  }

  // put classes on selected size
  selectSize(size) {
    let prevSize = this.dom.box.querySelector('.selected');
    if (prevSize) {
      prevSize.classList.remove(this.CLASSES.selected);
      size.closest(this.SELECTORS.sizeRadioBox).setAttribute("aria-checked","false");
    }
    size.closest(this.SELECTORS.sizeRadioBox).setAttribute("aria-checked","true");
    size.closest(this.SELECTORS.sizeRadioBox).classList.add(this.CLASSES.selected);
    this.liveRegion.sayMessage(size.closest(this.SELECTORS.sizeRadioBox).dataset.announceSelected);
  }

  bindEvents() {
    let ctx = this;
    // pdp CTA
    if (this.dom.sizes.length) {
      let allSizesUnavailable = true;
      this.dom.sizes.forEach(size => {
        size.addEventListener('click', () => {
          // put size
          this.selectSize(size);

          // display size next to Size label
          ctx.dom.selectedSize.innerHTML = ": " + size.parentNode.innerText;

          // if not available launch notify me event
          if (size.dataset.unavailable === 'true') {
            // TODO: remove size from payloads?
            this.$emit(this.$customEvents.PRODUCT_EVENTS.notifyme, {size: size.getAttribute('data-product-code'), box: this.dom.box});
            this.$emit(this.$customEvents.CHANGE_RETURN_STEPS.disabledConfirm, {size: size});
          } else {
            // if available i want to hide the notifyme form
            this.$emit(this.$customEvents.PRODUCT_EVENTS.notifymeclose, {size: size.getAttribute('data-product-code'), box: this.dom.box});
            this.$emit(this.$customEvents.CHANGE_RETURN_STEPS.enableConfirm, {size: size});
          }
          if (size.dataset.lowStock === "true") {
            this.dom.lowStockMsg.classList.remove("hidden");
          } else {
            this.dom.lowStockMsg.classList.add("hidden");
          }
          // general event
          this.$emit(this.$customEvents.PRODUCT_EVENTS.sizechanged, {
            productCode: size.dataset.productCode,
            isWishlist: size.dataset.isWishlist
          });
          this.dom.noSizeMsg.classList.add("hidden");
          // reset error
          // find error box
          let sizeErrorBox = document.querySelector('[data-sizes-error=prod_' + this.$component.dataset.productCode + ']');
          if (sizeErrorBox && !sizeErrorBox.classList.contains('hidden')) {
            sizeErrorBox.classList.add('hidden');
            sizeErrorBox.innerHTML = '';
          }
        });

        const label = size.closest('label');
        label.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            size.click();
          }
        });

        if (size.dataset.unavailable !== 'true') {
          allSizesUnavailable = false;
        }
      });

      window.addEventListener('load', () => {
        if (allSizesUnavailable) {
          // if every size is unavailable, fire event on load
          console.log("notifyme event");
          this.$emit(this.$customEvents.PRODUCT_EVENTS.notifyme, {unavailable: true, box: this.dom.box});
        }
      });
    }

    this.$on(this.$customEvents.SIZES_EVENTS.sizesupdate, ({payload}) => {
      this.dom.sizes.forEach(size => {
        if (size.dataset.productCode === payload.code) {
          size.dataset.isWishlist = payload.isWishlist;
        }
      });
    });

    this.$on(this.$customEvents.SIZES_EVENTS.noSizeSelected, () => {
      this.dom.noSizeMsg.classList.remove("hidden");
    });
  }

  render() {
    this.log('Rendering...');
    this.dom = this.readDOM();
    this.bindEvents();
  }
}
